export default __webpack_public_path__ + "static/media/random9.976851e7.jpeg";